import {
  FETCH_STATE_DATA,
  FETCH_STATE_DATA_SUCCESS,
  FETCH_STATE_DATA_FAILURE,
  FETCH_DISTRICT_DATA,
  FETCH_DISTRICT_DATA_SUCCESS,
  FETCH_DISTRICT_DATA_FAILURE,
  FETCH_TALUKA_DATA,
  FETCH_TALUKA_DATA_SUCCESS,
  FETCH_TALUKA_DATA_FAILURE,
  FETCH_PHC_DATA,
  FETCH_PHC_DATA_SUCCESS,
  FETCH_PHC_DATA_FAILURE,
  FETCH_PROGRAM_DATA,
  FETCH_PROGRAM_DATA_SUCCESS,
  FETCH_PROGRAM_DATA_FAILURE,
  FETCH_SCHEME_DATA,
  FETCH_SCHEME_DATA_SUCCESS,
  FETCH_SCHEME_DATA_FAILURE,
  FETCH_SUBCENTER_DATA,
  FETCH_SUBCENTER_DATA_SUCCESS,
  FETCH_SUBCENTER_DATA_FAILURE,
  FETCH_TRAINING_DATA,
  FETCH_TRAINING_DATA_SUCCESS,
  FETCH_TRAINING_DATA_FAILURE,
  FETCH_FACULTY_DATA,
  FETCH_FACULTY_DATA_SUCCESS,
  FETCH_FACULTY_DATA_FAILURE,
  FETCH_AREA_TYPE_DATA,
  FETCH_AREA_TYPE_DATA_SUCCESS,
  FETCH_AREA_TYPE_DATA_FAILURE,
  FETCH_AREA_CATEGORY_DATA,
  FETCH_AREA_CATEGORY_DATA_SUCCESS,
  FETCH_AREA_CATEGORY_DATA_FAILURE,
  FETCH_ROLE_DATA,
  FETCH_ROLE_DATA_SUCCESS,
  FETCH_ROLE_DATA_FAILURE,
  FETCH_VILLAGE_DATA,
  FETCH_VILLAGE_DATA_SUCCESS,
  FETCH_VILLAGE_DATA_FAILURE,
  RESET_DROPDOWN_OPTIONS,
  FETCH_LGB_DATA,
  FETCH_LGB_DATA_SUCCESS,
  FETCH_LGB_DATA_FAILURE,
  FETCH_ACCESS_LEVEL_DATA,
  FETCH_ACCESS_LEVEL_DATA_SUCCESS,
  FETCH_ACCESS_LEVEL_DATA_FAILURE,
  FETCH_CORPORATION_DATA,
  FETCH_CORPORATION_DATA_SUCCESS,
  FETCH_CORPORATION_DATA_FAILURE,
} from "./DropdownMastersAction";

const defaultState = {
  stateOptionsData: [],
  isStateLoading: false,

  districtOptionsData: [],
  isDistrictLoading: false,

  talukaOptionsData: [],
  isTalukaLoading: false,

  phcOptionsData: [],
  isPhcLoading: false,

  programOptionsData: [],
  isProgramLoading: false,

  schemeOptionsData: [],
  isSchemeLoading: false,

  trainingOptionsData: [],
  isTrainingLoading: false,

  facultyOptionsData: [],
  isFacultyLoading: false,

  lgbOptionsData: [],
  isLgbLoading: false,

  subcenterOptionsData: [],
  isSubcenterLoading: false,

  villageOptionsData: [],
  isVillageLoading: false,

  roleOptionsData: [],
  isRoleLoading: false,

  accessLevelOptionsData: [],
  isAccessLevelLoading: false,

  areaTypeOptionsData: [],
  isAreaTypeLoading: false,

  areaCategoryOptionsData: [],
  isAreaCategoryLoading: false,

  corporationOptionsData: [],
  isCorporationLoading: false,
};
const actionHandlers = {
  [FETCH_STATE_DATA]: (state) => ({
    ...state,
    isStateLoading: true,
  }),
  [FETCH_STATE_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    stateOptionsData: payload,
    isStateLoading: false,
  }),
  [FETCH_STATE_DATA_FAILURE]: (state) => ({
    ...state,
    isStateLoading: false,
  }),
  [FETCH_CORPORATION_DATA]: (state) => ({
    ...state,
    isCorporationLoading: true,
  }),
  [FETCH_CORPORATION_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    corporationOptionsData: payload,
    isCorporationLoading: false,
  }),
  [FETCH_CORPORATION_DATA_FAILURE]: (state) => ({
    ...state,
    isCorporationLoading: false,
  }),
  [FETCH_ACCESS_LEVEL_DATA]: (state) => ({
    ...state,
    isAccessLevelLoading: true,
  }),
  [FETCH_ACCESS_LEVEL_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    accessLevelOptionsData: payload,
    isAccessLevelLoading: false,
  }),
  [FETCH_ACCESS_LEVEL_DATA_FAILURE]: (state) => ({
    ...state,
    isAccessLevelLoading: false,
  }),
  [FETCH_DISTRICT_DATA]: (state) => ({
    ...state,
    talukaOptionsData: [],
    phcOptionsData: [],
    subcenterOptionsData: [],
    villageOptionsData: [],
    isDistrictLoading: true,
  }),
  [FETCH_DISTRICT_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    districtOptionsData: payload,
    isDistrictLoading: false,
  }),
  [FETCH_DISTRICT_DATA_FAILURE]: (state) => ({
    ...state,
    isDistrictLoading: false,
  }),
  [FETCH_TALUKA_DATA]: (state) => ({
    ...state,
    phcOptionsData: [],
    subcenterOptionsData: [],
    villageOptionsData: [],
    isTalukaLoading: true,
  }),
  [FETCH_TALUKA_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    talukaOptionsData: payload,
    isTalukaLoading: false,
  }),
  [FETCH_TALUKA_DATA_FAILURE]: (state) => ({
    ...state,
    isTalukaLoading: false,
  }),
  [FETCH_PHC_DATA]: (state) => ({
    ...state,
    subcenterOptionsData: [],
    villageOptionsData: [],
    isPhcLoading: true,
  }),
  [FETCH_PHC_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    phcOptionsData: payload,
    isPhcLoading: false,
  }),
  [FETCH_PHC_DATA_FAILURE]: (state) => ({
    ...state,
    isPhcLoading: false,
  }),
  [FETCH_PROGRAM_DATA]: (state) => ({
    ...state,
    isProgramLoading: true,
  }),
  [FETCH_PROGRAM_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    programOptionsData: payload,
    isProgramLoading: false,
  }),
  [FETCH_PROGRAM_DATA_FAILURE]: (state) => ({
    ...state,
    isProgramLoading: false,
  }),
  [FETCH_SCHEME_DATA]: (state) => ({
    ...state,
    isSchemeLoading: true,
  }),
  [FETCH_SCHEME_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    schemeOptionsData: payload,
    isSchemeLoading: false,
  }),
  [FETCH_SCHEME_DATA_FAILURE]: (state) => ({
    ...state,
    isSchemeLoading: false,
  }),
  [FETCH_TRAINING_DATA]: (state) => ({
    ...state,
    isTrainingLoading: true,
  }),
  [FETCH_TRAINING_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    trainingOptionsData: payload,
    isTrainingLoading: false,
  }),
  [FETCH_TRAINING_DATA_FAILURE]: (state) => ({
    ...state,
    isTrainingLoading: false,
  }),
  [FETCH_FACULTY_DATA]: (state) => ({
    ...state,
    isFacultyLoading: true,
  }),
  [FETCH_FACULTY_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    facultyOptionsData: payload,
    isFacultyLoading: false,
  }),
  [FETCH_FACULTY_DATA_FAILURE]: (state) => ({
    ...state,
    isFacultyLoading: false,
  }),
  [FETCH_SUBCENTER_DATA]: (state) => ({
    ...state,
    villageOptionsData: [],
    isSubcenterLoading: true,
  }),
  [FETCH_SUBCENTER_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    subcenterOptionsData: payload,
    isSubcenterLoading: false,
  }),
  [FETCH_SUBCENTER_DATA_FAILURE]: (state) => ({
    ...state,
    isSubcenterLoading: false,
  }),
  [FETCH_AREA_TYPE_DATA]: (state) => ({
    ...state,
    isAreaTypeLoading: true,
  }),
  [FETCH_AREA_TYPE_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    areaTypeOptionsData: payload,
    isAreaTypeLoading: false,
  }),
  [FETCH_AREA_TYPE_DATA_FAILURE]: (state) => ({
    ...state,
    isAreaTypeLoading: false,
  }),
  [FETCH_AREA_CATEGORY_DATA]: (state) => ({
    ...state,
    isAreaCategoryLoading: true,
  }),
  [FETCH_AREA_CATEGORY_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    areaCategoryOptionsData: payload,
    isAreaCategoryLoading: false,
  }),
  [FETCH_AREA_CATEGORY_DATA_FAILURE]: (state) => ({
    ...state,
    isAreaCategoryLoading: false,
  }),
  [FETCH_VILLAGE_DATA]: (state) => ({
    ...state,
    isVillageLoading: true,
  }),
  [FETCH_VILLAGE_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    villageOptionsData: payload,
    isVillageLoading: false,
  }),
  [FETCH_VILLAGE_DATA_FAILURE]: (state) => ({
    ...state,
    isVillageLoading: false,
  }),
  [FETCH_ROLE_DATA]: (state) => ({
    ...state,
    isRoleLoading: true,
  }),
  [FETCH_ROLE_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    roleOptionsData: payload,
    isRoleLoading: false,
  }),
  [FETCH_LGB_DATA]: (state) => ({
    ...state,
    isLgbLoading: true,
  }),
  [FETCH_LGB_DATA_SUCCESS]: (state, payload) => ({
    ...state,
    lgbOptionsData: payload,
    isLgbLoading: false,
  }),
  [FETCH_LGB_DATA_FAILURE]: (state) => ({
    ...state,
    isLgbLoading: false,
  }),
  [FETCH_ROLE_DATA_FAILURE]: (state) => ({
    ...state,
    isRoleLoading: false,
  }),
  [RESET_DROPDOWN_OPTIONS]: (state) => ({
    ...state,
    talukaOptionsData: [],
    phcOptionsData: [],
    subcenterOptionsData: [],
    villageOptionsData: [],
    schemeOptionsData: [],
    areaCategoryOptionsData: [],
    lgbOptionsData: [],
  }),
};

const DropdownMastersReducer = (state = defaultState, action = {}) => {
  const handler = actionHandlers[action.type];
  return handler ? handler(state, action.payload) : state;
};

export default DropdownMastersReducer;
